/** @format */

import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import I18n from '../../../../core/i18n';

interface QueueMultiSelectProps {
    titleTransKey: string;
    labelId: string;
    selectId: string;
    queues: string[];
    selectedQueues: string[];
    onQueueChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

const QueueMultiSelect: React.FC<QueueMultiSelectProps> = ({
    titleTransKey,
    labelId,
    selectId,
    queues,
    selectedQueues,
    onQueueChange,
}) => {
    const getQueueLabel = (queueName: string): string => {
        return I18n.t(`specialized_report:dashboard.queues.${queueName}`);
    };

    const renderValue = (selected: unknown): string => {
        return (selected as string[]).map((queueName) => getQueueLabel(queueName)).join(', ');
    };

    return (
        <Card>
            <CardHeader title={I18n.t(titleTransKey)} />
            <CardContent>
                <FormControl style={{ minWidth: 200 }}>
                    <InputLabel id={labelId}>
                        {I18n.t('specialized_report:dashboard.select_queue')}
                    </InputLabel>
                    <Select
                        labelId={labelId}
                        id={selectId}
                        multiple
                        value={selectedQueues}
                        onChange={onQueueChange}
                        renderValue={renderValue}
                    >
                        {queues.map((queueName) => (
                            <MenuItem key={queueName} value={queueName}>
                                {I18n.t(`specialized_report:dashboard.queues.${queueName}`)}

                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </CardContent>
        </Card>
    );
};

export default QueueMultiSelect;
